import { AuthService } from '@/auth/service/auth.service';
import { TaskCategories } from '@/enums/tasks';
import { ApprovalsService } from '@/services/approvals/approvals.service';
import { StoreState } from '@/store';
import { State } from '@/store/login/reducer';
import { getCurrentUserData } from '@/store/login/selectors';
import { normalize } from '@/utils/normalizeString';
import { ofuscate } from '@/utils/obfuscation';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { delay, map, mergeMap } from 'rxjs/operators';
import { ApprovalDetailList } from '../../../../../interfaces/approvals/approvals';

interface ApprovalDetailListWithEnabled extends ApprovalDetailList {
  enabled: boolean;
}

@Component({
  templateUrl: './pendings-list.component.html',
  styleUrls: ['./pendings-list.component.css'],
})
export class PendingsListComponent implements OnInit {

  gettingList: boolean = true;
  searchText = '';
  listRequestApprovalApi: Partial<ApprovalDetailListWithEnabled[]> = []
  panelOpenState: boolean = false;
  isInprocessRequest: boolean = false;
  userData: Partial<State> = {};

  shouldShowDelegatorNameColumn = false;
  shouldShowAssignedColumn = false;

  constructor(
    private serviceApproval: ApprovalsService,
    private router: Router,
    private store: Store<StoreState>,
    private authService: AuthService,
  ) {

  }

  ngOnInit() {
        getCurrentUserData(this.store).subscribe({
      next: (userData) => {
        this.userData = userData;
        const approvalPending$ = of({}).pipe(delay(3000), mergeMap(() => this.serviceApproval.getRequestApprovalPending(userData.mdmid)
          .pipe(
            map((arr) => arr.map((data) => ({ ...data, requirementTypeName: normalize(data.requirementType.name) }))),
          )));

        approvalPending$.subscribe({
          next: (response) => {
            this.gettingList = false;
            const myRole = this.authService.getUserRoleName();
            this.shouldShowDelegatorNameColumn = response.some((row) => !!row.delegatorName);
            this.shouldShowAssignedColumn = response.some((row) => (row.assignedName ? normalize(row.assignedName) !== normalize(userData.fullName) : false));
            this.listRequestApprovalApi = response.map((row) => ({
              ...row,
              enabled: !row.assignedName || normalize(row.assignedName) === normalize(userData.fullName) || myRole === 'DLMS_OWNER_MEL' || myRole === 'DLMS_OWNER_SPC',
            }));
          },
          error: () => {
            this.gettingList = false;
            this.listRequestApprovalApi = [];
          },
        });
      },
    });
  }

  goToApproval(requirementId: number, requirementTypeId: number) {

    if (requirementTypeId === TaskCategories.APROBACION) {
      const ofuscatedData = ofuscate({ id: requirementId, requirementTypeId });
      this.router.navigateByUrl(`/license/approve/detail/${ofuscatedData}`);
    }
    if (requirementTypeId === TaskCategories.DELEGACION) {
      const ofuscatedData = ofuscate({ id: requirementId, requirementTypeId });
      this.router.navigateByUrl(`/license/approve/detail/${ofuscatedData}`);
    }
    if (requirementTypeId === TaskCategories.RENOVACION) {
      const ofuscatedData = ofuscate({ id: requirementId, requirementTypeId });
      this.router.navigateByUrl(`/license/approve/detail/${ofuscatedData}`);
    }
    if (requirementTypeId === TaskCategories.AMPLIACION) {
      const ofuscatedData = ofuscate({ id: requirementId, requirementTypeId });
      this.router.navigateByUrl(`/license/approve/detail/${ofuscatedData}`);
    }

  }

  /// ///////////PAGINATE/////////////////

  config: any = {
    id: 'custom',
    itemsPerPage: 10,
    currentPage: 1,
    totalItems: this.listRequestApprovalApi.length,
  };
  public maxSize: number = 30;
  public directionLinks: boolean = true;
  public autoHide: boolean = false;
  public responsive: boolean = true;

  /// ////  ORDENAMIENTO ///////////
  order: string = '';
  // 1 -> disabled ; 2 -> asc ; 3 -> desc
  orderStatus: 1 | 2 | 3 = 1;
  reverse: boolean = false;

  setOrder(headerName: string) {
    if (this.order !== headerName) {
      this.orderStatus = 2;
      this.order = headerName;
    }
    else if (this.orderStatus < 3) {
      this.orderStatus++;
    }
    else {
      this.orderStatus = 1;
      this.order = '';
    }

    if (this.orderStatus === 3) {
      this.reverse = true;
    }
    else {
      this.reverse = false;
    }
  }

}
